import { Ui24Info } from "@ids/react-icons";
import { TypographyUI } from "@ids/react-typography";
import { useMemo } from "react";

type PopoverButtonProps = {
  triggerAriaLabel?: string;
  onClick: () => void;
  label?: string | null;
};

export const PopoverButton = ({
  triggerAriaLabel,
  onClick,
  label,
}: PopoverButtonProps) => {
  const accessibleLabel = useMemo(() => {
    if (triggerAriaLabel) {
      return triggerAriaLabel;
    }
    return "Näytä lisätietoja";
  }, [triggerAriaLabel]);

  return (
    <button
      type="button"
      className="if border-none background-transparent cursor-pointer"
      aria-label={accessibleLabel}
      title={accessibleLabel}
      onClick={onClick}
    >
      <div className="if  flex-row gap-8 align-items-center">
        <Ui24Info size={24} aria-hidden={true} focusable={false} />
        {label && (
          <TypographyUI as="span" isUnderlined={true}>
            {label}
          </TypographyUI>
        )}
      </div>
    </button>
  );
};
